import React from "react"
import InputLabel from "./InputLabel"

interface iCalculatorInputWrapper {
  children: any
  label: string
  unit?: string | null
  extendedInfo: string
  hideUnit: boolean
}

const CalculatorInputWrapper: React.FC<iCalculatorInputWrapper> = ({
  children,
  label,
  unit,
  hideUnit,
  extendedInfo,
}) => (
  <div className="text-blue-900 mb-4 sm:mb-8 ">
    <InputLabel
      label={label}
      unit={unit}
      extendedInfo={extendedInfo}
      hideUnit={hideUnit}
    />
    {children}
  </div>
)

export default CalculatorInputWrapper
